<script>
  import { _ as t } from "svelte-i18n";

  import InLineInput from "./InLineInput.svelte";

  export let data;
  export let errors;
</script>

<p class="conversation">
  {$t("conversation.denomination")}
  <InLineInput
    bind:value={data.officialName}
    label={$t("data.officialName")}
    long
  />
  {$t("conversation.fiscal")}
  <InLineInput
    bind:value={data.companyFiscalCode}
    label={$t("data.companyFiscalCode")}
    long
  />
  {$t("conversation.tva")}
  <InLineInput
    bind:value={data.companyTvaNumber}
    label={$t("data.companyTvaNumber")}
    long
  />
  .
</p>
<p class="conversation">
  {$t("conversation.hq")}
  <InLineInput
    bind:value={data.companyAddress}
    label={$t("data.companyAddress")}
  />
  ,
  <InLineInput
    bind:value={data.companyZipCode}
    label={$t("data.companyZipCode")}
  />
  <InLineInput bind:value={data.companyCity} label={$t("data.companyCity")} />
  <InLineInput
    bind:value={data.companyCountry}
    label={$t("data.companyCountry")}
  />
  {$t("conversation.pec")}
  <InLineInput bind:value={data.pecEmail} label={$t("data.pecEmail")} long />
  .
</p>
<p class="conversation">
  {$t("conversation.attorney")}
  <InLineInput
    bind:value={data.firstName}
    label={$t("data.firstName")}
    error={errors["first_name"]}
  />
  <InLineInput bind:value={data.lastName} label={$t("data.lastName")} />
  {$t("conversation.attorneyBorn")}
  <InLineInput
    bind:value={data.birthDate}
    label={$t("data.birthDate")}
    type="date"
  />
  {$t("conversation.where")}
  <InLineInput bind:value={data.birthPlace} label={$t("data.birthPlace")} />
  {$t("conversation.province")}
  <InLineInput bind:value={data.birthState} label={$t("data.birthState")} />
  <span style="display: inline-block">
    (
    <InLineInput
      bind:value={data.birthCountry}
      label={$t("data.birthCountry")}
    />
    ).
  </span>
</p>
<p class="conversation">
  {$t("conversation.attorneySsn")}
  <InLineInput
    bind:value={data.fiscalCode}
    label={$t("data.fiscalCode")}
    long
  />
  {$t("conversation.attorneyResidence")}
  <InLineInput bind:value={data.address} label={$t("data.address")} />
  ,
  <InLineInput bind:value={data.zipCode} label={$t("data.zipCode")} />
  <InLineInput bind:value={data.city} label={$t("data.city")} />
  {$t("conversation.province")}
  <InLineInput bind:value={data.state} label={$t("data.state")} />
  <span style="display: inline-block">
    (
    <InLineInput bind:value={data.country} label={$t("data.country")} />
    ).
  </span>
</p>

<style>
  p {
    margin: 48px 0 0;
    font-size: 14px;
  }

  .conversation {
    font-size: 16px;
    letter-spacing: 0.03rem;
    color: var(--gray-color);
  }

  @media only screen and (min-width: 600px) {
    .conversation {
      font-size: 22px;
      letter-spacing: 0.03rem;
      color: var(--gray-color);
    }
  }
</style>
